import React from 'react';
import { Chip, Stack, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getWeaponGroupShortLabel } from '@helpers/weaponGroups';
import { WeaponGroupChipsProps } from './interfaces';

export const WeaponGroupChips: React.FC<WeaponGroupChipsProps> = ({
  weaponGroups,
  size = 'small',
}): JSX.Element | null => {
  const { t } = useTranslation();

  if (!weaponGroups.length) {
    return null;
  }

  return (
    <Stack direction="row" flexWrap="wrap" gap={0.5} useFlexGap>
      {weaponGroups.map((group) => (
        <Tooltip
          key={group}
          title={t(`competitions:weaponGroups.${group}.label`)}
        >
          <Chip
            label={getWeaponGroupShortLabel(group)}
            size={size}
            variant="outlined"
          />
        </Tooltip>
      ))}
    </Stack>
  );
};
